/**
 * LQA Design System - Primitive Colors
 * These are the base color tokens used throughout the design system
 */

export const primitiveColors = {
	zinc: {
		50: '#FAFAFA',
		100: '#F4F4F5',
		200: '#E4E4E7',
		300: '#D4D4D8',
		400: '#A1A1AA',
		500: '#71717A',
		600: '#52525B',
		700: '#3F3F46',
		800: '#27272A',
		900: '#18181B',
		950: '#09090B',
	},
	brandBlue: {
		50: '#F2F8FD',
		100: '#E3EFFB',
		200: '#C1DFF6',
		300: '#8AC5EF',
		400: '#4BA8E5',
		500: '#248ED3',
		600: '#1670B3',
		700: '#135991',
		800: '#144C78',
		900: '#133857',
		950: '#0F2942',
	},
	green: {
		50: '#F4FAF3',
		100: '#E6F4E4',
		200: '#CEE8CA',
		300: '#A8D4A1',
		400: '#82BD7A',
		500: '#559B4C',
		600: '#427F3A',
		700: '#366530',
		800: '#2E512A',
		900: '#274324',
		950: '#112310',
	},
	navy: {
		50: '#F8F8ED',
		100: '#EDEFD8',
		200: '#DCE0B6',
		300: '#C6CB8B',
		400: '#ADB566',
		500: '#909A48',
		600: '#717A36',
		700: '#565E2D',
		800: '#464C28',
		900: '#3D4225',
		950: '#1F2310',
	},
	orange: {
		50: '#FEF8EE',
		100: '#FDEFD7',
		200: '#FBDAAD',
		300: '#F7BF7A',
		400: '#F39A44',
		500: '#F18832',
		600: '#E16315',
		700: '#BB4B13',
		800: '#943C18',
		900: '#783316',
		950: '#411709',
	},
	amber: {
		50: '#FEFAEC',
		100: '#FAF1CB',
		200: '#F4E293',
		300: '#EFCD5A',
		400: '#EBB934',
		500: '#DE971B',
		600: '#C97816',
		700: '#A75716',
		800: '#884318',
		900: '#703817',
		950: '#401D08',
	},
	red: {
		50: '#FDF4F3',
		100: '#FBE7E5',
		200: '#F9D3CF',
		300: '#F4B4AD',
		400: '#EC887D',
		500: '#DE594A',
		600: '#CC4536',
		700: '#AB372A',
		800: '#8E3126',
		900: '#762E26',
		950: '#40140F',
	},
	violet: {
		50: '#F6F4FD',
		100: '#EFECF9',
		200: '#E1DBF5',
		300: '#CABEEE',
		400: '#AF99E2',
		500: '#8A63D2',
		600: '#8453C7',
		700: '#7044A7',
		800: '#5E398C',
		900: '#4E3073',
		950: '#311E4D',
	},
	fuchsia: {
		50: '#FBF5FE',
		100: '#F8EBFC',
		200: '#F0D5F9',
		300: '#E6B4F3',
		400: '#D787EB',
		500: '#C662DE',
		600: '#A839C0',
		700: '#8D2C9F',
		800: '#752682',
		900: '#63246B',
		950: '#3F0C46',
	},
	teal: {
		50: '#F8FBFA',
		100: '#E5F4F0',
		200: '#CBE8E1',
		300: '#ACD7CF',
		400: '#8FC1B9',
		500: '#5BB3A6',
		600: '#429388',
		700: '#3A7670',
		800: '#33605B',
		900: '#30504D',
		950: '#162E2D',
	},
	simple: {
		white: '#FFFFFF',
		black: '#000000',
		transparent: 'transparent',
	},
} as const;
